@import 'src/global/media_queries'
  
:host 
  display: block
  width: 100%
  position: relative
  z-index: 1

.triangle
  width: 100%
  height: calc(100vw * 1/14)
  position: relative
  background-color: #E9E7E7

  &.triangle-top
    position: absolute
    clip-path: polygon(0 100%, 100% 0, 100% 100%)
    bottom: calc(100% - 1px)

  &.triangle-bottom
    clip-path: polygon(0 0, 0 100%, 100% 0)
    top: -1px

.main-content

  .top-bar
    width: 100%
    display: grid
    grid-template-columns: 1fr
    grid-template-areas: 'title' 'nav'

    @include media(">=tablet")
      grid-template-columns: 3fr 2fr 3fr
      grid-template-rows: 1fr
      grid-template-areas: 'return title nav'

    & *
      align-self: center

    div
      display: none
      grid-area: return

      @include media(">=tablet")
        display: block

    h1
      grid-area: title
      font-size: var(--fs-l)
      font-family: var(--ff-manrope)

    afs-nav
      grid-area: nav
      justify-self: center

      @include media(">=tablet")
        justify-self: flex-end

  .content
    width: 100%
    height: auto
    overflow: hidden

    .payment 
      display: none

      .card-reselect
        max-width: 22rem
        margin: 0 auto
        display: grid
        grid-template-columns: 1fr 1fr 1fr

        @include media(">=tablet")
          max-width: 35rem
          grid-template-columns: 2fr 1fr 2fr

        & > *
          align-self: center
          margin: 0 0.5rem

          &:first-child
            justify-self: flex-end
